import cn from 'classnames';
import styles from './socialmediaiconlinks.module.scss';
import { SocialMediaIconLinksProps, SocialMediaNames } from './SocialMediaIcon.type';
import { Link } from '@/ui-components/atoms/Link/Link';
import { IconFacebook } from '@/assets/icons/IconsFacebook';
import { IconInstagram } from '@/assets/icons/IconInstagram';
import { IconTikTok } from '@/assets/icons/IconTikTok';
import { IconXTwitter } from '@/assets/icons/IconXTwitter';
import { IconYouTube } from '@/assets/icons/IconYouTube';
import { IconEmail } from '@/assets/icons/IconEmail';

const ariaLabels = {
    facebook: 'Like us on Facebook',
    x: 'Follow us on Twitter',
    youtube: 'Watch us on YouTube',
    instagram: 'Follow us on Instagram',
    tiktok: 'Follow us on TikTok',
};

export function SocialMediaIconLinks({
    className,
    items,
    wrapIcons,
    isdarkTheme,
}: SocialMediaIconLinksProps): React.JSX.Element {
    const listClassNames = cn(styles.list, className, {
        [styles.wrapIcons]: wrapIcons,
        [styles.darkTheme]: isdarkTheme,
    });

    return (
        <ul className={listClassNames}>
            {items
                .sort((item1, item2) => item1.name.localeCompare(item2.name))
                .map((item, index) => {
                    const Icon = socialMediaIcons[item.name];

                    if (item.link?.href) {
                        const data = {
                            'data-linkname': item.name,
                        };

                        return (
                            <li key={index}>
                                <Link
                                    href={item.link.href}
                                    target={item.link?.linkTarget}
                                    aria-label={
                                        item.link?.ariaLabel || ariaLabels[item.name as keyof typeof ariaLabels]
                                    }
                                    {...data}
                                >
                                    <Icon />
                                </Link>
                            </li>
                        );
                    }
                })}
        </ul>
    );
}

const socialMediaIcons: { [name in SocialMediaNames]: React.JSX.ElementType } = {
    email: () => <IconEmail className={styles.emailIcon} />,
    facebook: () => <IconFacebook />,
    x: () => <IconXTwitter />,
    youtube: () => <IconYouTube />,
    instagram: () => <IconInstagram />,
    tiktok: () => <IconTikTok />,
} as const;
